import Firebase from 'firebase'

  var config = {
    apiKey: "AIzaSyDjGCuQB-aOc0qFZPNJTfF9Is-UywXakUg",
    authDomain: "dacade-mvp-1.firebaseapp.com",
    databaseURL: "https://dacade-mvp-1.firebaseio.com",
    projectId: "dacade-mvp-1",
    storageBucket: "",
    messagingSenderId: "1087159887585"
  };
  const firebaseApp = Firebase.initializeApp(config);
  const db = firebaseApp.database();
  export const dbSubmissionsRef = db.ref('submission');
  export const dbReviewsRef = db.ref('reviews');
  export const dbUserCollectionRef = db.ref('userCollection');





// WEBPACK FOOTER //
// ./src/firebaseConfig.js